import {createActor} from 'xstate'

import machine from '@components/OverlayManager/overlay-manager.machine'

const interpreter = createActor(machine).start()

export default function useOverlayManagerInterpreter() {
  return interpreter
}
